//---React Libraries
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
//---ANT Design
import { Col, Row, Select } from "antd";
import dayjs from "dayjs";
//---Project Imports
import "../style.css";
import AlarmCard from "./AlarmCard";
import DateTimePicker from "components/Common/DateTimePicker";
import { getFleetList, getVehicleList } from "apis/alertApis";

const SystemAlarms = ({ selectedTab, vehicleDetails }) => {
  const [dropdownDetails, setDropdownDetails] = useState({
    imeiList: [],
    allImeiList: [],
  });
  const [filterDetails, setFilterDetails] = useState({
    fleet: null,
    imeiList: vehicleDetails ? [vehicleDetails?.vehImei] : ["all"],
    category: "",
    dateRange: [
      dayjs()
        .subtract(dayjs().get("date") - 1, "d")
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0),
      dayjs(),
    ],
  });
  const authToken = localStorage.getItem("authToken");

  const { data: vehicleListData, isLoading: vehicleListLoading } = useQuery({
    queryKey: ["VehicleList", authToken],
    queryFn: () => getVehicleList(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (vehicleListData?.length > 0) {
      setDropdownDetails((prev) => ({
        ...prev,
        imeiList: vehicleListData || [],
        allImeiList: vehicleListData || [],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleListData]);

  const { data: fleetListData, isLoading: fleetListLoading } = useQuery({
    queryKey: ["FleetList", authToken],
    queryFn: () => getFleetList(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const onFilterChange = (name, value) => {
    if (["fleet"].includes(name)) {
      const imeiList =
        fleetListData.find((fleet) => fleet.fleetId === value)?.vehicleIds ||
        dropdownDetails?.allImeiList;
      setDropdownDetails((prev) => ({ ...prev, imeiList }));
      setFilterDetails((prev) => ({
        ...prev,
        [name]: value || null,
        imeiList: imeiList?.[0] ? ["all"] : [],
        current: 1,
      }));
    } else if (name === "imeiList") {
      const [firstImei, ...otherImei] = value;
      const selectedImei =
        !value?.length || otherImei.at(-1) === "all"
          ? ["all"]
          : firstImei === "all"
          ? otherImei
          : value;
      setFilterDetails((prev) => ({
        ...prev,
        imeiList: selectedImei,
        current: 1,
      }));
    } else {
      setFilterDetails((prev) => ({ ...prev, [name]: value, current: 1 }));
    }
  };

  return (
    <Row className="system-alarm-page" data-testid="system-alarms">
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Select
              allowClear
              showSearch
              value={filterDetails?.fleet}
              size="large"
              style={{ width: "100%" }}
              loading={fleetListLoading}
              data-testid="alert-fleet-dropdown"
              onChange={(value) => onFilterChange("fleet", value)}
              options={[
                { label: "None", value: null },
                ...(fleetListData || [])?.map((i) => ({
                  label: i.fleetName,
                  value: i.fleetId,
                })),
              ]}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Select
              allowClear
              size="large"
              mode="multiple"
              placeholder="IMEI"
              loading={vehicleListLoading}
              data-testid="alert-imei-dropdown"
              className={
                "w100" +
                (!filterDetails?.imeiList?.includes("all")
                  ? " imei-values"
                  : "")
              }
              value={filterDetails?.imeiList}
              maxTagCount={"responsive"}
              status={
                filterDetails?.imeiList?.length === 1 &&
                !filterDetails?.imeiList.includes("all")
                  ? "error"
                  : null
              }
              onChange={(value) => onFilterChange("imeiList", value)}
            >
              {dropdownDetails?.imeiList?.length > 0 && (
                <Select.Option value="all">All</Select.Option>
              )}
              {dropdownDetails?.imeiList?.map((data, i) => (
                <Select.Option key={i} value={data?.vehId}>
                  {data?.vehImei}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={8} lg={12} xl={12} className="flex-end">
            <DateTimePicker
              dates={filterDetails?.dateRange}
              onChangePicker={(value) => onFilterChange("dateRange", value)}
              disableRange={1}
              disableRangeType={"M"}
              featureDate={true}
              extraFilter={true}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="mt1 mb1">
          <Col xs={24} md={12}>
            <AlarmCard
              partType={"BMS"}
              authToken={authToken}
              selectedTab={selectedTab}
              filterDetails={filterDetails}
              setFilterDetails={setFilterDetails}
              onFilterChange={onFilterChange}
            />
          </Col>
          <Col xs={24} md={12}>
            <AlarmCard
              partType={"MCU"}
              authToken={authToken}
              selectedTab={selectedTab}
              filterDetails={filterDetails}
              setFilterDetails={setFilterDetails}
              onFilterChange={onFilterChange}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SystemAlarms;
